// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title = "Solar Panels in Sukkur | Best Solar Company in Sukkur,Larkana,Quetta - Solidera Energy",
  description = "Solidera Energy provides affordable solar panel installation in Sukkur, Rohri & Khairpur. Website developed by MZR Software.",
  image,
  url = "https://solidera-energy.com/",
}) => {
  const baseUrl = "https://solidera-energy.com";

  const defaultImage = `${baseUrl}/logo.png`;

  const keywords =
    "solar panels Sukkur, solar system Sukkur price,mzr software, solar installation Sukkur, best solar company Sukkur, net metering Sukkur";

  const fullUrl = url.startsWith("http") ? url : baseUrl + url;

  const fullImage = image
    ? image.startsWith("http")
      ? image
      : baseUrl + image
    : defaultImage;

  // ✅ Main Business Schema
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Solidera Energy",
    url: baseUrl,
    image: defaultImage,
    telephone: "+923337111075",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Sukkur",
      addressRegion: "Sindh",
      addressCountry: "PK",
    },
    areaServed: "Sukkur",
    description:
      "Solar panel installation, solar system supply, inverter and battery solutions in Sukkur Pakistan",
    sameAs: [
      "https://www.instagram.com/solid_era_energy/",
      "https://www.facebook.com/profile.php?id=61574004411820",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+923337111075",
      contactType: "customer service",
      areaServed: "PK",
      availableLanguage: ["English", "Urdu"],
    },
  };

  // ✅ Your Company (Developer Credit)
  const developerSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "MZR Software",
    url: "https://www.mzrsoftware.com/",
    logo: "https://www.mzrsoftware.com/logo.png",
  };

  return (
    <Helmet>
      {/* Title */} <title>{title}</title>
      ```
      {/* SEO */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta
        name="author"
        content="Solidera Energy | Developed by MZR Software"
      />
      <meta name="robots" content="index, follow" />
      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      {/* Credit Link (hidden but SEO useful) */}
      <link rel="developer" href="https://www.mzrsoftware.com/" />
      {/* Schema */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(developerSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
